import MapBase from "./components/Map/MapBase";
import { StrictMode } from "react";
import { Provider } from 'react-redux'
import { store } from "./redux/store";
import AppErrorBoundary from "./components/AppErrorBoundary";
import Footer from "./components/Footer";
import Header from "./components/Header";
import RequireLogin from "./components/Login/RequireLogin";

export function App() {
    return (
        <AppErrorBoundary>
            <Provider store={store}>
                <RequireLogin allowPublic={true}>
                    <div className="h-full flex flex-col">
                        <StrictMode>
                            <Header />
                            <MapBase />
                            <Footer />
                        </StrictMode>
                    </div>
                </RequireLogin>
            </Provider>
        </AppErrorBoundary>
    )
}